/**
 * Single source of truth for site navigation.
 *
 * Imported by BOTH the React shell (Header.jsx, Footer.jsx) and the static
 * Library generator (scripts/library/lib/shell.mjs). Add a nav item once and
 * it appears in the SPA header, the SPA mobile menu, the static Library
 * header and the footer — there is no second list to keep in step.
 *
 * `.mjs` is deliberate: Node imports it directly with no transpile step, and
 * webpack 5 resolves it inside the CRA bundle. Keep this file free of
 * imports so both loaders stay happy.
 *
 * `isStatic: true` marks a target that is pre-rendered HTML on disk rather
 * than a react-router route. Those MUST render as a plain <a href> in the
 * SPA — a <Link> would be intercepted by the router, match path="*" and
 * render the 404 page.
 */

export const productLinks = [
  {
    to: "/payroll",
    label: "Kedbyte Payroll",
    desc: "UK payroll for bureaux & accountants — in development",
  },
  {
    to: "/schoolos",
    label: "Kedbyte SchoolOS",
    desc: "School management for Indian K-12 — in active development",
  },
];

export const primaryLinks = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { label: "Products", children: productLinks },
  { to: "/library/", label: "Library", isStatic: true },
  { to: "/about", label: "About" },
  { to: "/careers", label: "Careers" },
];

/** Appended to the mobile menu only. */
export const mobileExtraLinks = [{ to: "/contact", label: "Contact" }];

export const footerCols = [
  {
    title: "Company",
    links: [
      { to: "/", label: "Home" },
      { to: "/about", label: "About" },
      { to: "/careers", label: "Careers" },
      { to: "/services", label: "Services" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { to: "/services", label: "Custom Software & Apps" },
      { to: "/services", label: "Frontend & Backend" },
      { to: "/services", label: "AI & Machine Learning" },
      { to: "/services", label: "Blockchain & Web3" },
      { to: "/services", label: "DevOps & Automation" },
      { to: "/services", label: "UI/UX Design" },
    ],
  },
];

export const footerProducts = [
  { to: "/payroll", label: "Kedbyte Payroll", testid: "footer-payroll-link" },
  { to: "/schoolos", label: "Kedbyte SchoolOS", testid: "footer-schoolos-link" },
  {
    to: "/library/",
    label: "KedByte Library",
    testid: "footer-library-link",
    isStatic: true,
  },
];

/** Legal identity as it appears in the site footer. */
export const company = {
  name: "KedByte Technologies Private Limited",
  email: "techteam@kedbyte.com",
  city: "Vadodara",
  region: "Gujarat",
  country: "India",
  incorporated: "08 May 2026",
};
